<template>
  <div class="card" :style="cardStyles" @click="handleButtonClick">
    <div
      v-if="singleText"
      :class="useSingleTextCenter ? 'single-text-center' : 'single-text-inline'"
      :style="singleContentStyles">
      <span :style="fontStyles">{{ content }}</span>
    </div>
    <div class="card-content" :style="contentStyles">
      <slot name="card-content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CCard",
  props: {
    content: {
      type: String,
      required: false,
    },
    singleText: {
      type: Boolean,
      required: false,
      default: false,
    },
    useSingleTextCenter: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: "auto",
    },
    width: {
      type: String,
      required: false,
      default: "auto",
    },
    margin: {
      type: String,
      required: false,
      default: "0px",
    },
    padding: {
      type: String,
      required: false,
      default: "0px",
    },
    borderColor: {
      type: String,
      required: false,
      default: "var(--gray-300)",
    },
    borderRadius: {
      type: String,
      required: false,
      default: "8px",
    },
    singleMargin: {
      type: String,
      required: false,
      default: "0px",
    },
    singlePadding: {
      type: String,
      required: false,
      default: "0px",
    },
    pointer: {
      type: Boolean,
      required: false,
      default: false,
    },
    fontColor: {
      type: String,
      required: false,
      default: "var(--gray-700)",
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "var(--white)",
    },
    fontWeight: {
      type: String,
      required: false,
      default: "400",
    },
    fontSize: {
      type: String,
      required: false,
      default: "16px",
    },
  },
  computed: {
    cardStyles() {
      return {
        height: this.height,
        width: this.width,
        cursor: this.pointer ? "pointer" : "default",
        backgroundColor: this.getColorVariable(this.backgroundColor),
        border: `1px solid ${this.getColorVariable(this.borderColor)}`,
        borderRadius: this.borderRadius,
      };
    },
    singleContentStyles() {
      return {
        margin: this.singleMargin,
        padding: this.singlePadding,
      };
    },
    contentStyles() {
      return {
        margin: this.margin,
        padding: this.padding,
      };
    },
    fontStyles() {
      return {
        fontWeight: this.fontWeight,
        fontSize: this.fontSize,
        color: this.getColorVariable(this.fontColor),
      };
    },
  },
  methods: {
    getColorVariable(color) {
      switch (color) {
        case "p400":
          return "var(--primary-400)";
        case "white":
          return "var(--white)";
        case "g700":
          return "var(--gray-700)";
        default:
          return color;
      }
    },
    handleButtonClick() {
      this.$emit("button-click");
    },
  },
};
</script>

<style scoped>
.card {
  border: 1px solid var(--gray-300);
  width: 100%;
  height: 100%;
}

.single-text-inline {
  line-height: 16px;
  display: inline-flex;
  align-items: center;
}
.single-text-center {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
